var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"rb-install"},[(_vm.step == '1')?_c('rb1'):_vm._e(),(_vm.step == '2')?_c('rb2'):_vm._e(),(_vm.step == '3')?_c('rb3'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }